// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3ZapX","savePackageButton":"ClientWallet_savePackageButton__1udOa"};